import { Deal } from '../../../modules/store/dochubApi/dochubTypes'

export const getMetaPaySources = (deal: Deal) => {
    const set = new Set<string>()

    if (deal.meta?.paySource) {
        set.add(deal.meta.paySource)
    }

    deal.meta?.payments?.forEach(payment => {
        if (payment.paySource) {
            set.add(payment.paySource)
        }
    })

    return Array.from(set)
}
